import React, { useState } from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row } from 'antd';
import bg1 from '../assets/images/产品优势-边缘计算网关.jpg';
import bg2 from '../assets/images/产品优势-物联网与数据中台.jpg';
import bg3 from '../assets/images/产品优势-低代码应用开发平台.jpg';
import bg4 from '../assets/images/产品优势-数字孪生可视化系统.jpg';
import { getChildrenToRender } from './utils';

const bgList = [bg1, bg2, bg3, bg4];

function Feature7(props) {
  const [activeId, setActiveId] = useState(0);
  const { dataSource, isMobile, ...tagProps } = props;
  const { blockWrapper, titleWrapper } = dataSource;
  const childrenToRender = blockWrapper.children.map((item, i) => (
    <div {...item} key={i.toString()} className={(i === activeId ? 'active ' : '') + item.className} onMouseEnter={() => handleMouseEnter(i)}>
      <a {...item.children}>
        {item.children.children.map(getChildrenToRender)}
      </a>
    </div>
  ));

  function handleMouseEnter(i) {
    setActiveId(i);
  }

  return (
    <div {...tagProps} {...dataSource.wrapper}
      style={{
        backgroundImage: `url(${bgList[activeId]})`,
      }}
    >
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim
            key="queue"
            type="bottom"
            leaveReverse
            interval={50}
            component={Row}
            {...blockWrapper}
          >
            {childrenToRender}
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
}

export default Feature7;
